import { useCategoriesAndProductsContextProvider } from '../../state';

interface BlockData {
    content: string;
}

function decodeHtml(html: string): string {
    const txt = document.createElement("textarea");
    txt.textContent = html;
    return txt.value;
}

export function Blocks() {
    const { blockData1, blockData2 } = useCategoriesAndProductsContextProvider();

    const renderBlockContent = (blockData: BlockData | null) => {
        if (!blockData) return null;
        return <div dangerouslySetInnerHTML={{__html: decodeHtml(blockData.content)}}></div>;
    };

    return (
        <div className={'mb-12'}>
            {renderBlockContent(blockData1)}
            {renderBlockContent(blockData2)}
        </div>
    );
};
